import { defineMessages } from 'react-intl';

const translations = {
  configure: {
    id: 'properties.configure',
    defaultMessage: 'Configure',
    description: 'Label of the configure button in the credentials item',
  },
  notConfigured: {
    id: 'properties.notConfigured',
    defaultMessage: 'Not configured',
    description: 'Not configured message of the credentials item',
  },
  edit: {
    id: 'actions.edit',
    defaultMessage: 'Edit',
    description: 'Label of the edit button in the credentials item',
  },
  feedback: {
    credentialsUpdated: {
      id: 'credentialItem.feedback.credentialsUpdated',
      defaultMessage: 'Credentials are updated',
      description: 'Success message of updating the credentials',
    },
    credentialsNotUpdated: {
      id: 'credentialItem.feedback.credentialsNotUpdated',
      defaultMessage: 'Credentials could not be updated',
      description: 'Error message of updating the credentials',
    },
  },
};

export default defineMessages(translations);
